import { render, staticRenderFns } from "./TableSet.vue?vue&type=template&id=50c1c44f&scoped=true&"
import script from "./TableSet.vue?vue&type=script&lang=js&"
export * from "./TableSet.vue?vue&type=script&lang=js&"
import style0 from "./TableSet.vue?vue&type=style&index=0&id=50c1c44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1c44f",
  null
  
)

export default component.exports